/* eslint-disable @typescript-eslint/no-use-before-define */
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getMimeType } from 'helpers/requestParams'
import invoiceDownloadAPI from 'services/invoiceDownload'
import { InvoiceDownloadRequest } from 'typings/invoices'
import { ServerError } from 'typings/serverError'
import { InvoicesDownloadResponse } from './typings'

export const initState: InvoicesDownloadResponse = {
  error: false,
  errorMessage: ''
}

export const getInvoiceDownload = createAsyncThunk(
  'invoiceDownloadSlice/getInvoiceDownload',
  async (payload: InvoiceDownloadRequest, { dispatch }) => {
    try {
      const response = await invoiceDownloadAPI.getInvoiceDownload(payload)

      const { fileFormat, source = '' } = payload
      const blobValue = response as unknown as string
      const { type, fileName } = getMimeType(fileFormat)
      const file = new Blob([blobValue], { type })
      const filePath = URL.createObjectURL(file)

      // TODO: user function from downloads helper module
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(file, fileName)
        dispatch(
          updateInvoiceDownloadState({
            error: false,
            errorMessage: ''
          })
        )
        return
      }

      const anchorTag = document.createElement('A') as HTMLAnchorElement
      anchorTag.href = filePath
      anchorTag.download = fileName
      anchorTag.id = 'tempInvoiceDownloadLink'
      if (source) {
        document.getElementById(source).appendChild(anchorTag)
        anchorTag.click()
      } else {
        document.body.appendChild(anchorTag)
        anchorTag.click()
      }
      document.getElementById('tempInvoiceDownloadLink').remove()

      dispatch(
        updateInvoiceDownloadState({
          error: false,
          errorMessage: ''
        })
      )
    } catch (error) {
      const {
        response: { message }
      } = error as ServerError

      dispatch(
        updateInvoiceDownloadState({
          error: true,
          errorMessage: message
        })
      )
    }
  }
)

const invoiceDownloadSlice = createSlice({
  name: 'invoiceDownloadSlice',
  initialState: initState,
  reducers: {
    updateInvoiceDownloadState: (
      state: InvoicesDownloadResponse,
      action: PayloadAction<InvoicesDownloadResponse>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    }
  }
})

export const { updateInvoiceDownloadState } = invoiceDownloadSlice.actions

export default invoiceDownloadSlice.reducer
